import React from 'react';
import { Show, EditButton, ReferenceManyField, Datagrid, TextField, ReferenceField, useRefresh, usePermissions, DeleteButton, SimpleShowLayout, RichTextField, Pagination, Button } from 'react-admin';
import BackButton from '../components/BackButton';
import CardActions from "@material-ui/core/CardActions";
import SystemAdd from '../systems/SystemAdd';
import ShowFormattedDate from '../components/ShowFormattedDate';
import CustomDateField from '../components/CustomDateField';
import CustomTextField from '../components/CustomTextField';
import CustomDefaultShowComponent from '../components/CustomDefaultShowComponent';
import InspectionAddFromList from '../inspections/InspectionAddFromList';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import SystemsIcon from '@material-ui/icons/Widgets';
import ISConfig from '../config';

const LocationsShowActions = (props) => {
    const { basePath } = props;

    return (
        <CardActions>
            <BackButton style={{ marginRight: "auto" }}></BackButton>
            <EditButton basePath={basePath} record={props.data} />
        </CardActions>
    );
};

const LocationShowGeneral = ({ record }) => {
    const { name, status, code } = record;

    return (
        <div className="row">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row row-cols-3 row-cols-lg-3 g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Code </h6>
                        {code ? code.length > 0 ? <span className="fw-italic m-0 p-0">{code}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Name</h6>
                        {name ? name.length > 0 ? <span className="fw-italic m-0 p-0">{name}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Status</h6>
                        {status ? status.length > 0 ? <span className="fw-italic m-0 p-0">{status}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                </div>
                <div className="row g-2 g-lg-2 mb-2">
                    <div >
                        <LocationShowAddress record={record} />
                    </div>
                </div>
                <div className="row g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Customer</h6>
                        <ReferenceField style={{ margin: '0px' }} label="" source="customer_id" resource="customers" reference="customers" link="show"><CustomTextField className="m-0 p-0" source="name" /></ReferenceField>
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 mb-3 m-o p-0">
                <LocationShowNotes record={record} />
            </div>
        </div>
    );
};

const LocationShowNotes = ({ record }) => {
    const { notes } = record;

    return (
        <div className="row h-100 w-100 m-0 p-0">
            <div>
                <h6 className="text-secondary" style={{ marginBottom: '10px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Notes</h6>
                <div className="p-2 pb-0 w-100 h-100" style={{ backgroundColor: 'rgb(255, 238, 201)', borderRadius: '0px 5px 5px 5px' }}>
                    {notes ? notes.length > 0 ? <RichTextField source="notes" style={{ fontSize: '1em' }} /> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                </div>
            </div>
        </div>
    );
};

const LocationShowAddress = ({ record }) => {
    const { address } = record;

    return (
        <div>
            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Address</h6>
            <div>
                {address.street ? address.street.length > 0 ? <span className="fw-italic">{address.street}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
            <div>
                {address.city ? address.city.length > 0 ? <span className="fw-italic">{address.city} </span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                {address.state ? address.state.length > 0 ? <span className="fw-italic text-uppercase">{address.state} </span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                {address.zip ? address.zip.length > 0 ? <span className="fw-italic text-uppercase">{address.zip} </span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
        </div>
    );
};

const LocationShowContact = ({ record }) => {
    const { contact } = record;

    return (
        <div className="d-flex justify-content-center w-50 g-2 g-lg-2 mb-2 row">
            <div className="col">
                <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Name</h6>
                <ReferenceField style={{ margin: '0px' }} label="" source="contact_id" resource="contacts" reference="contacts" link="show"><CustomTextField className="m-0 p-0" source="display_name" /></ReferenceField>
            </div>
            <div className="col">
                <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Phone</h6>
                <ReferenceField style={{ margin: '0px' }} label="" source="contact_id" resource="contacts" reference="contacts" link={false}><CustomTextField className="m-0 p-0" source="phone" /></ReferenceField>
            </div>
            <div className="col">
                <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Email</h6>
                <ReferenceField style={{ margin: '0px' }} label="" source="contact_id" resource="contacts" reference="contacts" link={false}><CustomTextField className="m-0 p-0" source="email" /></ReferenceField>
            </div>
        </div>
    );
};

const SystemDetails = ({ id, record, resource }) => {
    const { elements } = record;
    var elementskey = []

    for (const key in elements) {
        var elementskeycontent = [];
        var inspections = elements[key].inspections;
        for (const keyins in inspections) {
            elementskeycontent.push(
                <li id={keyins.charAt(0) + keyins.slice(1).replace('_', '') + '-li'} className="list-group-item">
                    <div className="row">
                        <div className="col d-flex align-items-center">
                            <h6 className="fw-light text-secondary">{ISConfig.frequencies[keyins].label}</h6>
                        </div>
                        <div className="col">
                            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Last Inspection</h6>
                            {inspections[keyins].last_inspection ? <ShowFormattedDate date={inspections[keyins].last_inspection} /> : CustomDefaultShowComponent}
                        </div>
                        <div className="col">
                            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Valid Until</h6>
                            {inspections[keyins].valid_until ? <ShowFormattedDate date={inspections[keyins].valid_until} /> : CustomDefaultShowComponent}
                        </div>
                    </div>
                </li>
            )
        }

        var elementskeycontentordered = [];
        ISConfig.frequencies_order.forEach(element => { elementskeycontentordered.push(elementskeycontent.filter(e => e.props.id == element+'-li')[0]) });
        elementskey.push(<ul className="list-group my-3" id={key.charAt(0) + key.slice(1).replace('_', '') + '-ul'}>
            <li class="list-group-item active text-dark fw-bold" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">{key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ')}</li>
            {elementskeycontentordered}
        </ul>
        );
    }

    return (
        <div>
            <div className="mt-0">
                {elementskey.filter(element => element.props.id == 'main-ul')[0]}
                {elementskey.filter(element => element.props.id == 'antifreeze-ul')[0]}
                {elementskey.filter(element => element.props.id == 'firepump-ul')[0]}
                {elementskey.filter(element => element.props.id == 'trip-ul')[0]}
            </div>
        </div>
    );
}

const CustomActionAddInspection = ({ record }) => {
    return (
        <div className="d-flex align-items-center" >
            <InspectionAddFromList className="d-inline-block" record={record} onChange={useRefresh()} />
        </div>
    )
}


const LocationShow = ({ backAction, ...props }) => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    let systemDeleteButton = null;
    if (isAdmin) { systemDeleteButton = ( <DeleteButton redirect={toRedirect} /> ) }

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Location</h3>
            <Show title=" " actions={<LocationsShowActions />} {...props}>
                <SimpleShowLayout className="">
                    <LocationShowGeneral className="mb-3" record={{ ...props }} />
                    <h6 className="font-weight-normal pt-2">{<PermPhoneMsgIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Contact</h6>
                    <LocationShowContact className="mb-3" record={{ ...props }} />
                    <div className="d-flex align-items-center">
                        <h5 className="font-weight-normal pt-2">{<SystemsIcon className="d-inline text-danger" style={{ fontSize: '38px' }} />} Systems </h5>
                        <SystemAdd className="d-inline-block" record={{ ...props }} onChange={useRefresh()} />
                    </div>
                    <ReferenceManyField
                        addLabel={false}
                        reference="systems"
                        target="location_id"
                        source="id"
                        sort={{ field: 'name', order: 'DESC' }}
                        display="flex" flex="0 0 100%" flexWrap="wrap"
                        pagination={<Pagination />}
                        perPage={10}
                        emptyText="Nothing to show"
                    >
                        <Datagrid className="table table-sm table-borderless" expand={<SystemDetails />}>
                            <ReferenceField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name </h6>} source="id" reference="systems" link="show" style={{ color: 'black' }}>
                                <TextField source="name" />
                            </ReferenceField>
                            <ReferenceField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Status </h6>} source="id" reference="systems" link="show" style={{ color: 'black' }}>
                                <TextField source="status" />
                            </ReferenceField>
                            <ReferenceField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Code </h6>} source="id" reference="systems" link="show" style={{ color: 'black' }}>
                                <TextField source="code" />
                            </ReferenceField>
                            <ReferenceField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Type </h6>} source="id" reference="systems" link="show" style={{ color: 'black' }}>
                                <TextField source="type" />
                            </ReferenceField>
                            <CustomDateField source="last_inspection" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Last Inspection </h6>} />
                            <CustomDateField source="next_deadline" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Next Deadline </h6>} />
                            <CustomActionAddInspection record={{ ...props }} />
                            {systemDeleteButton}
                        </Datagrid>
                    </ReferenceManyField>
                </SimpleShowLayout>
            </Show>
        </>
    );
}

export default LocationShow;